export default __webpack_public_path__ + "images/btc_186d8b.svg";